import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { getMapKey, isUndef } from '@/lib/utils';

export const typeNameToPath: Record<string, string> = {
    province: '',
    city: '',
    county: '',
};

export declare namespace RankV2 {
    interface RankV2Item {
        title: string;
        score: number;
        cover?: string
    }
    interface RankTemp {
        id: number
        monitor: string
        name: string
        member_count: string
        full_time: string
        reward: number
    }
    interface RankTempShare {
        id: number
        nickname: string
        avatar: string
        count: number
    }
}

export interface RankV2State {
    rankV2: {
        [type1_type2_activityid: string]: {
            list: RankV2.RankV2Item[],
            loaded: boolean
            req: boolean,
        },
    };
    rankTemp: {
        [activityId: string]: RankV2.RankTemp[]
    }
    rankShare: {
        [activityId: string]: ListWrap<RankV2.RankTempShare> & ListReq
    }
}

export const m: Module<RankV2State, RootState> = {
    namespaced: true,
    state: {
        rankV2: {},
        rankTemp: {},
        rankShare: {}
    },
    mutations: {
        initRankV2(state, { forceUpdate, key }) {
            const wrap = state.rankV2[key];
            if (wrap && forceUpdate) {
                wrap.loaded = wrap.req = false;
            } else {
                Vue.set(state.rankV2, key, {
                    list: [],
                    req: false,
                    loaded: false,
                });
            }
        },
        concatRankV2(state, { key, list, offset, forceUpdate }) {
            (list as RankV2.RankV2Item[]).forEach((ele, idx) => {
                Vue.set(state.rankV2[key].list, offset + idx, ele);
            });
            if (forceUpdate) {
                state.rankV2[key].list = state.rankV2[key].list.slice(0, list.length);
            }
        },
        setRankV2Req(state, { key, req }) {
            state.rankV2[key].req = req;
        },
        setRankV2Loaded(state, { key, loaded }) {
            state.rankV2[key].loaded = loaded;
        },
        setRankTemp(state, { list, activityId }) {
            Vue.set(state.rankTemp, activityId, list);
        },
        initRankShare(state, { forceUpdate, key }) {
            const wrap = state.rankShare[key];
            if (wrap && forceUpdate) {
                wrap.loaded = wrap.req = false;
            } else {
                Vue.set(state.rankShare, key, {
                    list: [],
                    req: false,
                    loaded: false,
                });
            }
        },
        concatRankShare(state, { key, list, offset, forceUpdate }) {
            (list as RankV2.RankTempShare[]).forEach((ele, idx) => {
                Vue.set(state.rankShare[key].list, offset + idx, ele);
            });
            if (forceUpdate) {
                state.rankShare[key].list = state.rankShare[key].list.slice(0, list.length);
            }
        },
        setRankShareReq(state, { key, req }) {
            state.rankShare[key].req = req;
        },
        setRankShareLoaded(state, { key, loaded }) {
            state.rankShare[key].loaded = loaded;
        },
    },
    actions: {
        async getRankV2({ state, commit, dispatch }, { offset, count, activityId, typeKey, levelId, forceUpdate }) {
            const key = getMapKey({
                activityId,
                typeKey,
                levelId
            });
            let wrap = state.rankV2[key];
            if (isUndef(wrap) || forceUpdate) {
                commit('initRankV2', { key, forceUpdate });
                wrap = state.rankV2[key];
            }
            if (wrap.loaded || wrap.req) {
                return;
            }
            commit('setRankV2Req', {
                key, req: true,
            });
            let rdata = null;
            if ([
                'team_thumb_up_rank',
                'user_thumb_up_rank',
            ].includes(typeKey)) {
                const res = await Vue.axios.get(`/api/v1/activity/${typeKey}`, {
                    params: { offset, count, id: activityId },
                });
                const list = res.data?.data.list || [];
                console.log('target 啊啊1', res.data);
                rdata = {
                    status: res.data.status,
                    // TeamThumbUpItem | UserThumbUpItem
                    data: list.map((ele: any) => {
                        let score = 0;
                        let title = '';
                        let cover = ''
                        if (typeKey === 'team_thumb_up_rank') {
                            score = ele.count;
                            title = ele.name;
                            cover = ele.logo
                        } else if (typeKey === 'user_thumb_up_rank') {
                            score = ele.thumb_up_count;
                            title = ele.nickname;
                        }
                        return {
                            title,
                            score,
                            cover
                        };
                    }),
                };
            } else if([
                'team_distance',
                'team_sign_in_rate',
                'user_distance',
                'user_days',
            ].includes(typeKey)) {
                // getTotalDistanceRank
                const map: Record<string, string> = {
                    team_sign_in_rate: 'rank/getTeamRank',
                    team_distance: 'rank/getTeamDistance',
                    user_distance: 'rank/getTotalDistanceRank',
                    user_days: 'rank/getTotalDaysRank',
                }
                const res = await dispatch(map[typeKey], {
                    levelId,
                    activityId,
                    offset,
                    count,
                    forceUpdate
                }, {
                    root: true
                });
                const list = res.data.list || [];
                rdata = {
                    status: res.status,
                    data: list.map((ele: TeamFinishedRateItem) => {
                        return {
                            // @ts-ignore
                            title: ele.name || ele.nickname,
                            // @ts-ignore
                            score: typeKey === 'team_sign_in_rate' ? ele.rate : (ele.total_distance || ele.count || 0),
                            cover: typeKey.indexOf('team') > -1 ? ele.logo : '',
                        };
                    }),
                }
            } else if(['team_member_count'].includes(typeKey)) {
                const res = await dispatch('getRankTemp', activityId);
                console.log('target ranktempres', res);
                rdata = {
                    status: res.status,
                    data: res.data.map((ele: RankV2.RankTemp) => ({
                        title: ele.name,
                        score: ele.member_count
                    }))
                }
            } else {
                const path = typeKey.replace('_', '/');
                const res = await Vue.axios.get(`/api/v1/rank/${path}`, {
                    params: { offset, count, activity_id: activityId },
                });
                rdata = res.data;
            }
            commit('setRankV2Req', {
                key, req: false,
            });
            if (rdata.status === 0) {
                commit('concatRankV2', {
                    offset,
                    list: rdata.data,
                    forceUpdate,
                    key,
                });
                if (rdata.data.length < count) {
                    commit('setRankV2Loaded', {
                        key, loaded: true,
                    });
                }
            }
            return rdata;
        },
        async getRankTemp({ commit }, activityId) {
            const res = await Vue.axios.get(`/api/v1/team/top_50`, {
                params: { activity_id: activityId },
            });
            const rdata = res.data;
            if(rdata.status === 0) {
                commit('setRankTemp', {
                    activityId,
                    list: rdata.data
                })
            }
            return rdata;
        },
        async getRankShare({ state, commit }, { offset, count, activityId, forceUpdate }) {
            const key = getMapKey({
                activityId,
            });
            let wrap = state.rankShare[key];
            if (isUndef(wrap) || forceUpdate) {
                commit('initRankShare', { key, forceUpdate });
                wrap = state.rankShare[key];
            }
            if (wrap.loaded || wrap.req) {
                return;
            }
            commit('setRankShareReq', {
                key, req: true,
            });
            const res = await Vue.axios.get(`/api/v1/invite/23rank`, {
                params: { offset, count },
            });
            const rdata = res.data;
            commit('setRankShareReq', {
                key, req: false,
            });
            if (rdata.status === 0) {
                commit('concatRankShare', {
                    offset,
                    list: rdata.data,
                    forceUpdate,
                    key,
                });
                if (rdata.data.length < count) {
                    commit('setRankShareLoaded', {
                        key, loaded: true,
                    });
                }
            }
            return rdata;
        },
    },
};
